import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Component3cards from '../components/component3cards'
import Component4cards from '../components/component4cards'
import Component3images from '../components/component3images'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './partners.css'

const Partners = (props) => {
  return (
    <div className="partners-container">
      <Helmet>
        <title>Официальные партнеры Arcobo | Kawasaki Robotics и Kolarc</title>
        <meta
          name="description"
          content="Arcobo — официальный партнер Kawasaki Robotics и Kolarc. Поставка оборудования, интеграция, сервис и техническая поддержка в Казахстане и Узбекистане."
        />
        <meta
          property="og:title"
          content="Официальные партнеры Arcobo | Kawasaki Robotics и Kolarc"
        />
        <meta
          property="og:description"
          content="Arcobo — официальный партнер Kawasaki Robotics и Kolarc. Поставка оборудования, интеграция, сервис и техническая поддержка в Казахстане и Узбекистане."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Официальные партнеры Arcobo | Kawasaki Robotics и Kolarc"
        />
        <meta
          name="twitter:description"
          content="Arcobo — официальный партнер Kawasaki Robotics и Kolarc. Поставка оборудования, интеграция, сервис и техническая поддержка в Казахстане и Узбекистане."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/partners"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/partners"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Partners","item":"https://arcobo.tech/partners"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name29"></HeaderMain>
      <Component3cards
        titleAs="h1"
        showBigTitle
        componentText="Arcobo сотрудничает с ведущими мировыми производителями промышленных роботов и сварочного оборудования. Мы поставляем оборудование, выполняем инженерную интеграцию, обучение персонала и сервисную поддержку предприятий Казахстана, Узбекистана и Центральной Азии."
        feature1Title="Kawasaki Robotics"
        rootClassName="component3cardsroot-class-name4"
        componentTitle="Официальные партнеры Arcobo"
        feature1Title2={
          <Fragment>
            <span className="partners-text10">
              Kawasaki
            </span>
          </Fragment>
        }
        feature2Title2={
          <Fragment>
            <span className="partners-text11">ASTOR </span>
          </Fragment>
        }
        feature3Title2={
          <Fragment>
            <span className="partners-text12">Kolarc</span>
          </Fragment>
        }
        feature1ImageSrc="/4_Company Arcobo/4_4_Partners/kawasaki%20v1-1500w.webp"
        feature1ImageAlt="Kawasaki Robotics"
        feature2ImageSrc="/4_Company Arcobo/4_4_Partners/astor-og%20jpeg-400h.webp"
        feature2ImageAlt="Astorino"
        feature3ImageSrc="/4_Company Arcobo/4_4_Partners/kolarc-400h.webp"
        feature3ImageAlt="Kolarc"
        feature1Description={
          <Fragment>
            <span className="partners-text13">
              <span className="partners-text14">
                Старейший японский производитель промышленных роботов
              </span>
              <br></br>
              <br></br>
              <span className="partners-text17">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Более 300 000 роботов внедрено на предприятиях по всему миру.
              </span>
              <br></br>
              <span className="partners-text20">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Широкая линейка решений для сварки, паллетирования и
                автоматизации.
              </span>
              <br></br>
              <span className="partners-text23">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Высокая надежность и круглосуточная промышленная эксплуатация.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature2Description1={
          <Fragment>
            <span className="partners-text26">
              <span className="partners-text27">
                Передовой центр промышленной роботизации в Восточной Европе
              </span>
              <br></br>
              <br></br>
              <span className="partners-text30">•</span>
              <span className="partners-text31">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Разработчик и п</span>
              <span>роизводитель учебных роботов Astorino;</span>
              <br></br>
              <span className="partners-text35">•</span>
              <span className="partners-text36">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Производитель позиционеров и периферийного оборудования под
                брендом Kawasaki;
              </span>
              <br></br>
              <span className="partners-text39">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Многолетний опыт внедрения роботизированных технологий в
                промышленности.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        feature3Description1={
          <Fragment>
            <span className="partners-text42">
              <span className="partners-text43">
                Турецкий производитель цифровых сварочных источников.
              </span>
              <br></br>
              <br></br>
              <span className="partners-text46">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Современные решения для MIG/MAG, TIG, MMA и роботизированной
                сварки.
              </span>
              <br></br>
              <span className="partners-text49">•</span>
              <span className="partners-text50">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Высокая стабильность сварочного процесса и надежная элементная
                база.
              </span>
              <br></br>
              <span className="partners-text53">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Оптимальное сочетание функциональности, качества и стоимости
                владения.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
      ></Component3cards>
      <Component4cards
        title1="Доступ к последним технологиям и программному обеспечению"
        title2="Поддержка сложных инженерных проектов"
        title3="Оригинальные комплектующие и запасные части"
        title4="Подготовка специалистов по международным стандартам"
        heading1="Работа с Arcobo даёт:"
        imageSrc="/icons/chip-200w.webp"
        imageAlt="Доступ к технологиям и ПО"
        imageSrc1="/icons/support-200w.webp"
        imageAlt1="Поддержка инженерных проектов"
        imageSrc2="/icons/parts-200w.webp"
        imageAlt2="Оригинальные комплектующие"
        imageSrc3="/icons/medal-200w.webp"
        imageAlt3="Подготовка специалистов"
        rootClassName="component4cardsroot-class-name2"
      ></Component4cards>
      <Component3images
        image1Src="/4_Company Arcobo/4_4_Partners/kia%20friends-200h.webp"
        image1Alt="Партнёры Arcobo"
        image2Src="/4_Company Arcobo/4_4_Partners/astor%20friends-200h.webp"
        image2Alt="Партнёры Arcobo"
        image3Src="/4_Company Arcobo/4_4_Partners/kolarc%20friends-200h.webp"
        image3Alt="Партнёры Arcobo"
        rootClassName="component3imagesroot-class-name25"
      ></Component3images>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="partners-text56">
              Да. Arcobo — официальный партнер Kawasaki Robotics и осуществляет
              поставку, интеграцию, программирование и сервисную поддержку
              промышленных роботов в Казахстане и Центральной Азии.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="partners-text57">
              Да. Мы поставляем отдельные роботы, сварочные источники Kolarc,
              позиционеры, захваты и другое оборудование, а также выполняем
              полный цикл внедрения «под ключ».
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="partners-text58">
              Нет. Мы обладаем опытом работы с KUKA, FANUC и Yaskawa, однако
              новые проекты реализуем преимущественно на платформе Kawasaki
              Robotics.
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="partners-text59">answer</span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="partners-text60">answer</span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="partners-text61">answer</span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="partners-text62">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="partners-text63">answer</span>
          </Fragment>
        }
        showDiv={false}
        showDiv1={false}
        showDiv2={false}
        showDiv3
        showDiv4
        showDiv5
        showDiv6
        showDiv7
        question1="Arcobo является официальным партнером Kawasaki Robotics?"
        question2="Можно ли приобрести оборудование без интеграции?"
        question3="Работает ли Arcobo только с Kawasaki Robotics?"
        rootClassName="componentfaqroot-class-name14"
      ></Componentfaq>
      <FooterMain></FooterMain>
    </div>
  )
}

export default Partners
